import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './action';
import userReducer from './user.action'

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    user : userReducer,
  },
});
